import React from 'react';
import { motion } from 'framer-motion';
import { FiSearch, FiMapPin } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section id="home" className="relative h-screen flex items-center justify-center">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat"
        style={{ 
          backgroundImage: 'url("https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2500&auto=format&fit=crop")',
        }}
      >
        <div className="absolute inset-0 bg-slate-900/60"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight leading-tight mb-6">
            Find Your <span className="text-amber-500 italic font-serif">Dream Home</span> <br /> in the City
          </h1>
          <p className="text-lg md:text-xl text-slate-200 max-w-2xl mx-auto mb-10 font-light">
            Expert guidance, exclusive luxury listings, and a seamless real estate experience tailored to your unique lifestyle.
          </p>
        </motion.div>

        {/* Search Bar Mockup */}
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-white rounded-lg p-2 md:p-4 shadow-xl max-w-4xl mx-auto flex flex-col md:flex-row gap-4"
        >
          <div className="flex-1 flex items-center bg-slate-50 rounded-md px-4 py-3 border border-slate-200">
            <SafeIcon icon={FiMapPin} className="text-slate-400 mr-3" />
            <input 
              type="text" 
              placeholder="City, Neighborhood, or Zip" 
              className="bg-transparent w-full outline-none text-slate-700 placeholder-slate-400"
            />
          </div>
          <div className="flex-1 flex items-center bg-slate-50 rounded-md px-4 py-3 border border-slate-200">
            <select className="bg-transparent w-full outline-none text-slate-700 cursor-pointer appearance-none">
              <option value="">Property Type</option>
              <option value="house">Single Family House</option>
              <option value="condo">Condo / Apartment</option>
              <option value="townhouse">Townhouse</option>
            </select>
          </div>
          <button className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-3 rounded-md font-medium transition-colors flex items-center justify-center">
            <SafeIcon icon={FiSearch} className="mr-2" />
            Search
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;